const warnOnNowHekate = () => {
  if (!window.hekateEventBus) {
    console.error('Hekate Event Bus is not initialized on window object', new Error().stack);
  }
};
export const useHekateEventBus = (): HekateEventBusType => {
  return {
    addEventListener: (evt: HekateEventName, cb: HekateEventBusCallback) => {
      if (!window) return;
      warnOnNowHekate();
      window.hekateEventBus.addEventListener(evt, cb);
    },
    removeEventListener: (evt: HekateEventName, cb: HekateEventBusCallback) => {
      if (!window) return;
      warnOnNowHekate();
      window.hekateEventBus.removeEventListener(evt, cb);
    },
    dispatchEvent: (evt: HekateEventName, detail?: JsonBlob) => {
      if (!window) return;
      warnOnNowHekate();
      window.hekateEventBus.dispatchEvent(evt, detail || {});
    },
  };
};
